import React from "react";
import { Link } from "react-router-dom";
import TagManager from 'react-gtm-module';
import { getImgUrl } from "../../Utility/Utility";
import { Img } from "../../Components/UI/UI";
import "./Footer.css";

const langLinks = [
  {
    lang: "uk",
    links: [
      {
        name: "ac-tripadvisor",
        nameImg: "Footer/1.png",
        nameLink:
          "https://www.tripadvisor.co.uk/Hotels-g293984-Tel_Aviv_Tel_Aviv_District-Hotels.html",
      },
      {
        name: "ac-trivago",
        nameImg: "Footer/2.png",
        nameLink:
          "http://www.trivago.co.uk/?aDateRange%5Barr%5D=2016-10-13&aDateRange%5Bdep%5D=2016-10-14&r=&cpt=8494803&iRoomType=1&aPriceRange%5Bto%5D=0&aPriceRange%5Bfrom%5D=0&iPathId=84948&iViewType=0&bIsSeoPage=false&bIsSitemap=false&",
      },
      {
        name: "ac-booking",
        nameImg: "Footer/3.png",
        nameLink:
          "https://www.booking.com/city/il/tel-aviv.en-gb.html?label=gen173nr-1DCAMoakIIdGVsLWF2aXZIM2IFbm9yZWZoaogBAZgBMcIBCndpbmRvd3MgMTDIAQzYAQPoAQH4AQKSAgF5qAID;sid=f953bdba74eb94e49dfbc75c631266c4;selected_currency=GBP;changed_currency=1;top_currency=1",
      },
      {
        name: "ac-expedia",
        nameImg: "Footer/4.png",
        nameLink:
          "https://www.expedia.co.uk/Tel-Aviv.d180031.Holidays-City-Breaks",
      },
      {
        name: "ac-hotels",
        nameImg: "Footer/5.png",
        nameLink: "https://uk.hotels.com/de699178/hotels-tel-aviv-israel/",
      },
    ],
  },
  {
    lang: "cz",
    links: [
      {
        name: "ac-tripadvisor",
        nameImg: "Footer/1.png",
        nameLink:
          "https://www.tripadvisor.co.uk/Hotels-g293984-Tel_Aviv_Tel_Aviv_District-Hotels.html",
      },
      {
        name: "ac-trivago",
        nameImg: "Footer/2.png",
        nameLink:
          "https://www.trivago.co.uk/?aDateRange%5Barr%5D=2016-10-13&aDateRange%5Bdep%5D=2016-10-14&r=&cpt=8494803&iRoomType=1&aPriceRange%5Bfrom%5D=0&aPriceRange%5Bto%5D=0&iPathId=84948&iViewType=0&bIsSeoPage=0&bIsSitemap=false",
      },
      {
        name: "ac-booking",
        nameImg: "Footer/3.png",
        nameLink:
          "https://www.booking.com/city/il/tel-aviv.en-gb.html?label=gen173nr-1DCAMoakIIdGVsLWF2aXZIM2IFbm9yZWZoaogBAZgBMcIBCndpbmRvd3MgMTDIAQzYAQPoAQH4AQKSAgF5qAID;sid=f953bdba74eb94e49dfbc75c631266c4;selected_currency=GBP;changed_currency=1;top_currency=1",
      },
      {
        name: "ac-expedia",
        nameImg: "Footer/4.png",
        nameLink:
          "https://www.expedia.com/Tourist-Information-Office-Tel-Aviv.d507139.Vacation-Attraction",
      },
      {
        name: "ac-hotels",
        nameImg: "Footer/5.png",
        nameLink: "https://uk.hotels.com/de699178/hotels-tel-aviv-israel/",
      },
    ],
  },
  {
    lang: "ro",
    links: [
      {
        name: "",
        nameLink: "",
      },
      {
        name: "",
        nameLink: "",
      },
      {
        name: "",
        nameLink: "",
      },
      {
        name: "",
        nameLink: "",
      },
      {
        name: "",
        nameLink: "",
      },
    ],
  },
  {
    lang: "dk",
    links: [
      {
        name: "ac-tripadvisor",
        nameImg: "Footer/1.png",
        nameLink:
          "https://www.tripadvisor.co.uk/Hotels-g293984-Tel_Aviv_Tel_Aviv_District-Hotels.html",
      },
      {
        name: "ac-trivago",
        nameImg: "Footer/2.png",
        nameLink:
          "https://www.trivago.co.uk/?aDateRange%5Barr%5D=2016-10-13&aDateRange%5Bdep%5D=2016-10-14&r=&cpt=8494803&iRoomType=1&aPriceRange%5Bfrom%5D=0&aPriceRange%5Bto%5D=0&iPathId=84948&iViewType=0&bIsSeoPage=0&bIsSitemap=false",
      },
      {
        name: "ac-booking",
        nameImg: "Footer/3.png",
        nameLink:
          "https://www.booking.com/city/il/tel-aviv.en-gb.html?label=gen173nr-1DCAMoakIIdGVsLWF2aXZIM2IFbm9yZWZoaogBAZgBMcIBCndpbmRvd3MgMTDIAQzYAQPoAQH4AQKSAgF5qAID;sid=f953bdba74eb94e49dfbc75c631266c4;selected_currency=GBP;changed_currency=1;top_currency=1",
      },
      {
        name: "ac-expedia",
        nameImg: "Footer/4.png",
        nameLink:
          "https://www.expedia.com/Tourist-Information-Office-Tel-Aviv.d507139.Vacation-Attraction",
      },
      {
        name: "ac-hotels",
        nameImg: "Footer/5.png",
        nameLink: "https://uk.hotels.com/de699178/hotels-tel-aviv-israel/",
      },
    ],
  },
  {
    lang: "se",
    links: [
      {
        name: "ac-tripadvisor",
        nameImg: "Footer/1.png",
        nameLink:
          "https://www.tripadvisor.co.uk/Hotels-g293984-Tel_Aviv_Tel_Aviv_District-Hotels.html",
      },
      {
        name: "ac-trivago",
        nameImg: "Footer/2.png",
        nameLink:
          "https://www.trivago.co.uk/?aDateRange%5Barr%5D=2016-10-13&aDateRange%5Bdep%5D=2016-10-14&r=&cpt=8494803&iRoomType=1&aPriceRange%5Bfrom%5D=0&aPriceRange%5Bto%5D=0&iPathId=84948&iViewType=0&bIsSeoPage=0&bIsSitemap=false",
      },
      {
        name: "ac-booking",
        nameImg: "Footer/3.png",
        nameLink:
          "https://www.booking.com/city/il/tel-aviv.sv.html?label=gen173nr-1DCAMoakIIdGVsLWF2aXZIM2IFbm9yZWZoaogBAZgBMcIBCndpbmRvd3MgMTDIAQzYAQPoAQH4AQKSAgF5qAID;sid=f953bdba74eb94e49dfbc75c631266c4;selected_currency=SEK;changed_currency=1",
      },
      {
        name: "ac-expedia",
        nameImg: "Footer/4.png",
        nameLink:
          "https://www.expedia.com/Tourist-Information-Office-Tel-Aviv.d507139.Vacation-Attraction",
      },
      {
        name: "ac-hotels",
        nameImg: "Footer/5.png",
        nameLink: "https://sv.hotels.com/de699178/hotels-tel-aviv-israel/",
      },
    ],
  },
  {
    lang: "hu",
    links: [
      {
        name: "ac-tripadvisor",
        nameImg: "Footer/1.png",
        nameLink:
          "https://www.tripadvisor.co.uk/Hotels-g293984-Tel_Aviv_Tel_Aviv_District-Hotels.html",
      },
      {
        name: "ac-trivago",
        nameImg: "Footer/2.png",
        nameLink:
          "https://www.trivago.co.uk/?aDateRange%5Barr%5D=2016-10-13&aDateRange%5Bdep%5D=2016-10-14&r=&cpt=8494803&iRoomType=1&aPriceRange%5Bfrom%5D=0&aPriceRange%5Bto%5D=0&iPathId=84948&iViewType=0&bIsSeoPage=0&bIsSitemap=false",
      },
      {
        name: "ac-booking",
        nameImg: "Footer/3.png",
        nameLink:
          "https://www.booking.com/city/il/tel-aviv.en-gb.html?label=gen173nr-1DCAMoakIIdGVsLWF2aXZIM2IFbm9yZWZoaogBAZgBMcIBCndpbmRvd3MgMTDIAQzYAQPoAQH4AQKSAgF5qAID;sid=f953bdba74eb94e49dfbc75c631266c4;selected_currency=GBP;changed_currency=1;top_currency=1",
      },
      {
        name: "ac-expedia",
        nameImg: "Footer/4.png",
        nameLink:
          "https://www.expedia.com/Tourist-Information-Office-Tel-Aviv.d507139.Vacation-Attraction",
      },
      {
        name: "ac-hotels",
        nameImg: "Footer/5.png",
        nameLink: "https://uk.hotels.com/de699178/hotels-tel-aviv-israel/",
      },
    ],
  },
  {
    lang: "nl",
    links: [
      {
        name: "ac-tripadvisor",
        nameImg: "Footer/1.png",
        nameLink:
          "https://www.tripadvisor.co.uk/Hotels-g293984-Tel_Aviv_Tel_Aviv_District-Hotels.html",
      },
      {
        name: "ac-trivago",
        nameImg: "Footer/2.png",
        nameLink:
          "https://www.trivago.co.uk/?aDateRange%5Barr%5D=2016-10-13&aDateRange%5Bdep%5D=2016-10-14&r=&cpt=8494803&iRoomType=1&aPriceRange%5Bfrom%5D=0&aPriceRange%5Bto%5D=0&iPathId=84948&iViewType=0&bIsSeoPage=0&bIsSitemap=false",
      },
      {
        name: "ac-booking",
        nameImg: "Footer/3.png",
        nameLink:
          "https://www.booking.com/index.nl.html?label=gen173nr-1DCAEoggJCAlhYSDNiBW5vcmVmaGqIAQGYARzCAQp3aW5kb3dzIDEwyAEM2AED6AEBkgIBeagCAw;sid=6bce782adff40da500a1f4beb44cbd99;sb_price_type=total&",
      },
      {
        name: "ac-expedia",
        nameImg: "Footer/4.png",
        nameLink:
          "https://www.expedia.com/Tourist-Information-Office-Tel-Aviv.d507139.Vacation-Attraction",
      },
      {
        name: "ac-hotels",
        nameImg: "Footer/5.png",
        nameLink: "https://nl.hotels.com/de699178/hotels-tel-aviv-israel/",
      },
    ],
  },
];

const FooterLink = (props) => {
  return (
    <div className="anoter-site-deal-logo">
      <a
        rel="noopener noreferrer"
        className={props.langName}
        href={props.href}
        target="_blank"
      >
        <Img desktopImg={props.langNameImg} />
      </a>
    </div>
  );
};

const Footer = () => {
  var lang = localStorage.getItem("currentLang");

  const langslinksObj = langLinks.find((o) => {
    return o.lang === lang;
  });

  // console.log("langslinksObj", langslinksObj);

  const currentlangLinks = langslinksObj.links.map((o) => {
    // console.log("ooooooo", o);
    return (
      <FooterLink
        key={o.name}
        langName={o.name}
        href={o.nameLink}
        langNameImg={o.nameImg}
      />
    );
  });

  return (
    <div className="Footer-outer-wrapper">
      <div className="container">
        <div className="row">
          <div className="col col-100 footer-menu-outer-wrapper">
            <div className="footer-images-wrapper">
              {/* <div className="tripadvisor-main-wrapper">
                <Img desktopImg="Footer/tripadvisorMain.png" />
              </div> */}
              <div className="info-main-wrapper">
                <a href="https://www.gov.il/en/service/virtual_office/">
                  <Img desktopImg="support.png" />
                </a>
              </div>
            </div>
            <div className="footer-menu-inner-wrapper footer-menu-inner-wrapper-1">
              <ul className="first">
                <li>
                  <Link className="first" to="/Pages/whereToGo" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'where to go', 'event_details':'', }})}>
                    WHERE TO GO
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Pages/TelAvivPage" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'tel aviv', 'event_details':'', }})}>TEL AVIV</Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Pages/JerusalemPage" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'jerusalem', 'event_details':'', }})}>JERUSALEM</Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Pages/DeadSeaPage" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'dead sea', 'event_details':'', }})}>DEAD SEA</Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
              </ul>

              <ul>
                <li>
                  <Link className="first" to="/Pages/thingsToDo" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'things to do', 'event_details':'', }})}>
                    THINGS TO DO
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/telaviv/Sensational_Beaches" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'sensational beaches', 'event_details':'', }})}>
                    SENSATIONAL BEACHES
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/telaviv/Go_To_Guide" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'go to guide', 'event_details':'', }})}>GO TO GUIDE</Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/telaviv/Day_IsTrippin" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'day tripin', 'event_details':'', }})}>DAY TRIPPIN'</Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
              </ul>

              <ul className="">
                <li>
                  <Link className="first" to="/Pages/Videos" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'videos', 'event_details':'', }})}>
                    VIDEOS
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/Videos/telaviv/Outdoor_Adventures" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'outdoor adventures', 'event_details':'', }})}>
                    OUTDOOR ADVENTURES
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/Videos/deadsea/Natural_Spa" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'the dead sea', 'event_details':'', }})}>
                    THE DEAD SEA
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/Videos/telaviv/Port_Pleasures" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'jaffa port', 'event_details':'', }})}>
                    JAFFA PORT
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
              </ul>

              <div className="clear"></div>
            </div>
            <div className="clear"></div>
            {/*<div className="ac-wrapper-telaviv-and-jerusalem-footer ac-flex ac-flex-row ac-flex-row-mob">
              <div className="telaviv-and-jerusalem-footer">
                <a
                  className="jer-site"
                  href="https://www.itraveljerusalem.com/"
                  target="_blank"
                  onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'the official tourism website of jerusalem', 'event_details':'', }})}
                >
                  THE OFFICIAL TOURISM WEBSITE OF JERUSALEM >>
                </a>
              </div>
              <div className="ac-verti-line hide-on-mobile"> </div>
              <div className="telaviv-and-jerusalem-footer">
                <a
                  className="tlv-site"
                  href="https://visit.tel-aviv.gov.il/home"
                  target="_blank"
                  onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'tel avivs official tourism website', 'event_details':'', }})}
                >
                  TEL AVIV'S OFFICIAL TOURISM WEBSITE >>
                </a>
              </div>
              <div className="telaviv-and-jerusalem-footer">
                <a
                  className="ac-privacy-policy"
                  href="https://goisrael.com/Posts/telaviv/Privacy_Policy"
                  target="_blank"
                  onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'privacy policy', 'event_details':'', }})}

                >
                  PRIVACY POLICY >>
                </a>
              </div>
            </div>*/}
          </div>
        </div>
        <div className="ac-social-wrapper">
                  <div className="ac-inner-social-wrapper">
                        <div className="ac-social-col ac-social-col-1">
                              <a href="https://www.instagram.com/visit_israel/" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'instagram', 'event_details':'', }})}>
                              <Img desktopImg="social/i.png" mobileImg="social/i.png"/>
                              </a>
                        </div>
                        {/* <div className="ac-social-col ac-social-col-2">
                              <a href="https://twitter.com/israeltourism" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'twitter', 'event_details':'', }})}>
                              <Img desktopImg="social/t.png" mobileImg="social/t.png"/>
                              </a>
                        </div> */}
                        <div className="ac-social-col ac-social-col-3">
                              <a href="https://www.youtube.com/@goisraelofficial" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'youtube', 'event_details':'', }})}>
                              <Img desktopImg="social/y.png" mobileImg="social/y.png"/>
                              </a>
                        </div>
                        <div className="ac-social-col ac-social-col-4">
                              <a href="https://www.flickr.com/photos/israelphotogallery/sets/" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'flickr', 'event_details':'', }})}>
                              <Img desktopImg="social/fl.png" mobileImg="social/fl.png"/>
                              </a>
                        </div>
                        <div className="ac-social-col ac-social-col-5">
                              <a href="https://www.facebook.com/goisrael" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'facebook', 'event_details':'', }})}>
                              <Img desktopImg="social/f.png" mobileImg="social/f.png"/>
                              </a>
                        </div>
                        <div className="ac-social-col ac-social-col-6">
                              <a href="https://www.tiktok.com/@visit_israel" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'tiktok', 'event_details':'', }})}>
                              <Img desktopImg="social/tiktok.png" mobileImg="social/tiktok.png"/>
                              </a>
                        </div>
                        <div className="ac-social-col ac-social-col-7">
                              <a href="https://www.linkedin.com/company/israel-ministry-of-tourism/" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'linkedin', 'event_details':'', }})}>
                              <Img desktopImg="social/linkedin.png" mobileImg="social/linkedin.png"/>
                              </a>
                        </div>
                  </div>
        </div>
        <div className="row">
          <div className="cradit">
            <p>
              Photographers: Guy Yehieli, Adam Primer, Kfir Boltin, Linnea
              Andres, Kfir Sivan, Haim Yafim, Dana Fridlander, refael Ben Ari,
              Itamar Greenberg, Moshik Lindbaum
            </p>
            <p>
              Video Credits: Israeli food channel, Tel Aviv Jaffa municipality,
              UDINI prodactions
            </p>
          </div>

          {/* <h4>
		       		For More Deals:
		       	</h4>
		       	<div className="clear"></div>
		       	<div className="sites-logos">
                                   {currentlangLinks}

		       	</div> */}

          <div className="clear"></div>
        </div>
      </div>
      <div className="container container-links">
        <ul>
          <li><a href="https://brochures.goisrael.com/"
                 target="_blank"
                 onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'brochures', 'event_details':'', }})}
              >OFFICIAL BROCHURE</a></li>
          <li><span> | </span></li>
          <li><a href="https://goisrael.com/Pages/Contact/"
                target="_blank"
                onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'contact us', 'event_details':'', }})}
              >CONTACT US</a></li>
               <li><span> | </span></li>
          <li><a href="https://israel.travel/terms-of-use/"
                  target="_blank"
                  onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'term of use', 'event_details':'', }})}
              >TERMS OF USE</a></li>
               <li><span> | </span></li>
          <li><a href="https://goisrael.com/Posts/telaviv/Privacy_Policy"
                  target="_blank"
                  onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'privacy policy', 'event_details':'', }})}
              >
                  PRIVACY POLICY
                </a></li>
                 <li><span> | </span></li>
          <li><a href="https://goisrael.com/Pages/Gallery/" 
                 target="_blank" 
                 onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'gallery', 'event_details':'', }})}
              >GALLERY</a></li>
               <li><span> | </span></li>
          <li><a href="https://goisrael.com/Posts/TouristInfo/Frequently_Asked_Questions"
                  target="_blank" 
                  onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'faq', 'event_details':'', }})}
              >FAQ</a></li>
        </ul>
      </div>
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js